import React, { ReactNode, useCallback, useEffect, useMemo, useState } from 'react';

import { Metadata } from '../../../shared/models/survey/Metadata';
import Survey from '../../../shared/models/survey/Survey';
import SurveyAnswer from '../../../shared/models/survey/SurveyAnswer';
import SurveyQuestion from '../../../shared/models/survey/SurveyQuestion';
import SurveyQuestionType from '../../../shared/models/survey/SurveyQuestionType';
import Events from '../../../shared/utils/events';
import getRoute from '../../../shared/utils/get-route';
import useSurvey from '../hooks/useSurvey';
import SurveyContext from './SurveyContext';

type PropType = {
  children: ReactNode[] | ReactNode;
};

const surveyTestAnswers = [
  { value: 23, questionId: 'f21b1948-d7b9-4062-ad55-7b3efc750036' },
  { value: ['bb9dc689-1eb5-4b5a-a598-b4835235e0fe'], questionId: '5e378874-7f7e-47ef-9549-12528c4fb92a' },
  { value: 190, questionId: '262ecdc1-1ef7-40fb-8f4f-c4d6da1ea886' },
  { value: 110, questionId: '3011fa8b-e489-4bb7-8f1c-2ba0e73f4116' },
  { value: ['4d1d7a89-424f-4a1f-a5af-30831f0731da'], questionId: '894e54b4-991f-42e6-bce9-f6e53926b09f' },
  { value: ['c5b4e730-7e3f-470e-9af0-6d8660db5ff6'], questionId: '72dea9a6-ce42-4115-87aa-904461896767' },
  { value: ['a7efb244-9634-4861-b100-38566d09099e'], questionId: '19a3276e-f15e-4c3d-b4f0-1d98e01e9b4c' },
  { value: ['41aea59a-9b81-42b7-8dd2-0b0383178645'], questionId: '35620127-2c8a-4152-9c7c-16721067dc92' },
  { value: ['2d67574a-f2e8-4893-b1ed-4743527f177f'], questionId: '6c3d68b3-b4c5-4c88-a8ff-ede0615f537d' },
  { value: ['df5de7e0-25cc-4ac1-a51f-036b6b739981'], questionId: '189a469b-a6b8-47e9-97ff-9ab46a66c0ee' },
  { value: ['813d90ca-7e61-43e5-a922-29676fc58d41'], questionId: 'c7da485e-03f6-4ab6-90aa-207b8744c583' },
  { value: ['9b457106-e1f9-450d-baef-5a343bd7d9a2'], questionId: '74862abb-2f34-4b2a-be0c-3e795421db8e' },
  { value: ['48d03fce-5156-4e46-bff7-4b3bcfd7c607'], questionId: '52b41225-4719-49ff-8047-244ef50168c6' },
  { value: ['a20b1b47-ad49-4bfc-955f-bf8837c3974e'], questionId: '0df8a010-1a82-453e-a43b-95ec65264405' },
  { value: ['42301a50-581e-4fc4-999b-9fd83080d23d'], questionId: 'e8f3e903-7e46-4b0a-bde3-0b4e764e3bdc' },
  { value: ['7c6cc246-2b6c-481a-9b5f-7468024227b2'], questionId: '891f8b9b-ea62-4de8-912d-4b2c0f89ccd2' },
  { value: ['4f7d332f-8efb-4c86-ab35-bca2bbca60d1'], questionId: '090418c2-d213-41cf-b02d-96fefd24b710' },
  { value: 10, questionId: '5c13ec14-d2f3-4424-8d8c-1f48fb777a27' },
  { value: 2, questionId: 'dbece3b9-5a3f-41dc-942d-49d7a5a83b08' },
  { value: 0, questionId: 'd39d6a57-d387-4c50-a3f6-3296914fcee2' },
  { value: 1, questionId: 'b259e8f2-e0c4-4bbc-a9dd-0d278b5b9425' },
  { value: ['d1b23038-8e9d-4276-be39-76da5700fe87'], questionId: 'dfb55139-2c5c-49be-b492-24f1cece6ede' },
  { value: ['446ce49f-bebe-40d1-9da0-285aa1392eb0'], questionId: '22aeb1e4-ef31-4ca4-a8c3-399f78d2e81b' },
  { value: ['4ce542ba-ef71-4c30-ae38-c3849d8fe2e2'], questionId: '04d21e1d-85db-4734-a338-39db2830453c' },
  { value: ['b9491aef-eead-49f1-9ae8-576f970a62e3'], questionId: '8c25e5a9-72da-46c9-a4ff-dbc20a42a46e' },
  { value: ['8e1f6ef1-22c2-4ccb-ae1a-bd42e896f503'], questionId: 'f33a9218-e018-4f5c-a287-bdcb0ff46e59' },
  { value: ['66a3476d-2e52-4115-84b9-4357e63341e7'], questionId: 'c28e7fcb-199a-4046-af9c-91893b814acb' },
  { value: ['1eb11aa0-a11f-4c16-abaf-5d9cc151e95f'], questionId: '5ead0297-c6bd-456b-b212-e782774ec730' },
  { value: ['e22bcbee-8a91-4eb7-8b01-8bdb98b444d0'], questionId: '1cefaa0c-48e1-41ae-b2c4-66f1baef8d53' },
  { value: ['a2e6a2d9-4245-43fa-b007-94658cd68bbe'], questionId: 'a4696ef6-3d40-45ed-9929-b1c171874336' },
  { value: ['36af1f43-6ef2-4929-a811-c352adf8ce6c'], questionId: 'f0a476f5-bb64-4eda-af50-0b4f7de9789b' },
  { value: ['f02b8ba2-abbc-4d74-882f-95ee05285e5f'], questionId: 'c63e7f7c-3113-4049-9d8d-a2f4855f874a' },
  { value: ['5d15f075-48a9-4b4f-8a5c-dd8b1b17db9a'], questionId: 'b8477a06-1e3c-4169-9615-b48c733cfd31' },
  { value: ['1714bb10-1e83-4c72-b8a4-6a371fe7fb7d'], questionId: '09aa7648-952a-4bfa-b445-6cdea6da6061' },
  { value: ['f32007a2-1b7e-449d-a4b0-bdfcdc607b28'], questionId: 'e48ed0bc-59a2-48fb-a993-c400927e8103' },
  { value: ['a06a8269-7fb0-46b1-a89a-4dd7bf21f4ef'], questionId: 'a1aab366-1a89-4fc0-a901-7a0e5cc8cda3' },
  { value: ['51bd7ba7-cf53-45b4-b51c-4c01ee51d95c'], questionId: '8b4af25f-51aa-49c3-a4c4-76245f5680d5' },
  { value: ['b3ea91ec-2307-431c-a408-2bacf2111526'], questionId: 'a16d9766-32ed-4c94-834f-7a2c7d29403c' },
];

const SurveyContextProvider = (props: PropType) => {
  const storedAnswers = JSON.parse(localStorage.getItem('gezondleven-answers-backup') ?? '[]');
  const storedActivationCode = sessionStorage.getItem('gezondleven-activation-code') ?? null;
  const parsedActivationCode = storedActivationCode === 'null' ? null : storedActivationCode;
  const [email, setEmail] = useState<string>('');
  const [survey, setSurvey] = useState<Survey | undefined>(undefined);
  const [questions, setQuestions] = useState<SurveyQuestion[]>([]);
  const [questionAnswers, setQuestionAnswers] = useState<SurveyAnswer[]>(storedAnswers ?? []);
  const [questionNumber, setQuestionNumber] = useState<number>(storedAnswers.length);
  const [question, setQuestion] = useState<SurveyQuestion | null>(null);
  const [activationCode, setActivationCode] = useState<string | null>(parsedActivationCode);
  const [sessionKey, setSessionKey] = useState<string>('');
  const [metadata, setMetadata] = useState<Metadata>();
  const [language, setLanguage] = useState<string>(() => localStorage.getItem('i18nextLng') ?? 'nl');

  useEffect(() => {
    const handleLanguageUpdate = () => {
      const newLanguage = localStorage.getItem('i18nextLng');
      if (newLanguage === null || newLanguage === 'null') {
        setLanguage('nl');
      } else {
        setLanguage(newLanguage);
      }
    };

    window.addEventListener(Events.LOCAL_STORAGE_UPDATE_LANGUAGE, handleLanguageUpdate);
    return () => {
      window.removeEventListener(Events.LOCAL_STORAGE_UPDATE_LANGUAGE, handleLanguageUpdate);
    };
  }, []);

  const { data: surveyData } = useSurvey(activationCode, language);

  useEffect(() => {
    if (surveyData?.specification) {
      setSurvey(surveyData.specification);
      setQuestions(surveyData.specification.questions);
    }
  }, [surveyData]);

  const getThemeName = (identifier: string): string => {
    const theme = survey?.themes?.find((surveyTheme) => surveyTheme.identifier === identifier);
    return theme?.name ?? '';
  };

  const getAdvice = (identifier: string, isPositive: boolean): string => {
    const adviceMapping = survey?.adviceMappings?.find(
      ({ identifier: surveyAdviceMappingIdentifier }) => surveyAdviceMappingIdentifier === identifier
    );
    if (!adviceMapping) return '';
    return isPositive ? adviceMapping.positiveName : adviceMapping.negativeName;
  };

  const getLink = (identifier: string): string => getRoute(identifier);

  const setQuestionAnswer = (questionAnswer: SurveyAnswer | undefined) => {
    let newAnswers: SurveyAnswer[];
    if (questionAnswer) {
      const { questionId: QuestionAnswerQuestionId } = questionAnswer;
      const answerIndex = questionAnswers.findIndex(({ questionId }) => questionId === QuestionAnswerQuestionId);

      if (answerIndex !== -1) {
        questionAnswers[answerIndex] = questionAnswer;
        newAnswers = [...questionAnswers];
      } else {
        newAnswers = [...questionAnswers, questionAnswer];
      }
    } else {
      newAnswers = [];
    }

    localStorage.setItem('gezondleven-answers', JSON.stringify(newAnswers));
    setQuestionAnswers(newAnswers);
  };

  const updateQuestionAnswers = (answers: SurveyAnswer[]) => {
    setQuestionAnswers([...answers]);
  };

  const resetAnswers = () => {
    const answers = JSON.parse(localStorage.getItem('gezondleven-answers-backup') ?? '');
    setQuestionAnswers([...answers]);
  };

  const getBackupQuestionAnswers = () => JSON.parse(localStorage.getItem('gezondleven-answers-backup') ?? '');

  const setBackupQuestionAnswers = (answers: SurveyAnswer[]) =>
    localStorage.setItem('gezondleven-answers-backup', JSON.stringify(answers));

  const setAllAnswers = () => {
    setQuestionAnswers(surveyTestAnswers);
    setQuestionNumber(surveyTestAnswers.length + 6);
  };

  const setEmailAddress = (address: string) => {
    if (address !== '') {
      localStorage.setItem('gezondleven-email', address);
    }
    setEmail(address);
  };

  const updateSurvey = useCallback((newSurvey: Survey) => {
    setSurvey(newSurvey);
    setQuestions(newSurvey.questions);
  }, []);

  const removeAnswers = () => {
    setQuestionAnswers([]);
    setQuestionNumber(0);
  };

  const updateActivationCode = (code: string | null) => {
    const codeToStore = code ?? 'null';
    sessionStorage.setItem('gezondleven-activation-code', codeToStore);
    window.dispatchEvent(new Event(Events.LOCAL_STORAGE_UPDATE_CODE));
    setActivationCode(code);
  };

  const updateSessionKey = (key: string) => {
    setSessionKey(key);
  };

  const onHandleNext = (finishCallback?: () => void) => {
    let surveyAnswer = questionAnswers.find((answer) => answer.questionId === questions[questionNumber].questionId);

    if (!surveyAnswer && questions[questionNumber].allowSkipWithDefaultValue) {
      const currentQuestion = questions[questionNumber];
      if (
        currentQuestion.questionType === SurveyQuestionType.NUMERIC_INPUT ||
        currentQuestion.questionType === SurveyQuestionType.NUMERIC_SLIDER
      ) {
        const numericQuestion = currentQuestion as any;
        const defaultAnswer = {
          questionId: currentQuestion.questionId,
          value: numericQuestion.min,
        };

        const newAnswers = [...questionAnswers, defaultAnswer];
        localStorage.setItem('gezondleven-answers', JSON.stringify(newAnswers));
        setQuestionAnswers(newAnswers);
        surveyAnswer = defaultAnswer;
      }
    }

    if (
      (question!.followUpRules.length === 0 && surveyAnswer !== undefined && questionNumber < questions.length) ||
      questions[questionNumber].questionType === SurveyQuestionType.CHAPTER_INTRODUCTION
    ) {
      setQuestionNumber(questionNumber + 1);
      return;
    }

    if (Array.isArray(surveyAnswer!.value)) {
      const matchingAnswer = (question as SurveyQuestion)?.followUpRules.find(
        (rule) => rule.selectedOptionId === (surveyAnswer!.value as Array<string>)[0]
      );

      if (!matchingAnswer && matchingAnswer === undefined) {
        setQuestionNumber(questionNumber + 1);
        return;
      }

      if (matchingAnswer.skipTo === '00000000-0000-0000-0000-000000000000') {
        finishCallback!();
        return;
      }

      const nextQuestionNumber = questions.findIndex((q) => q.questionId === matchingAnswer!.skipTo);
      setQuestionNumber(nextQuestionNumber);
    }
  };

  const findPreviousAnsweredQuestion = (currentQuestionNumber: number): string | null => {
    if (currentQuestionNumber <= 0) return null;

    const previousQuestionNumber = currentQuestionNumber - 1;

    if (questions[previousQuestionNumber].questionType === SurveyQuestionType.CHAPTER_INTRODUCTION) {
      return questions[previousQuestionNumber].questionId;
    }

    const previousQuestion = questionAnswers.find(
      (answer) => questions[previousQuestionNumber].questionId === answer.questionId
    );

    if (previousQuestion) {
      return previousQuestion.questionId;
    }

    return findPreviousAnsweredQuestion(previousQuestionNumber);
  };

  const onHandlePrevious = () => {
    const previousQuestionId = findPreviousAnsweredQuestion(questionNumber);
    const previousQuestionNumber = questions.findIndex((q) => q.questionId === previousQuestionId);
    if (previousQuestionNumber !== null) {
      setQuestionNumber(previousQuestionNumber);
    }
  };

  const updateMetadata = (newMetadata: Metadata) => {
    setMetadata(newMetadata);
  };

  const getMetadata = (identifier: string): string | undefined =>
    metadata?.images.find(({ identifier: imageIdentifier }) => imageIdentifier === identifier)?.imageUrl ?? undefined;

  const { children } = props;
  const context = useMemo(
    () => ({
      email,
      questionAnswers,
      questionNumber,
      survey,
      activationCode,
      sessionKey,
      question,
      setQuestion,
      setQuestionAnswer,
      setQuestionAnswers,
      updateQuestionAnswers,
      setBackupQuestionAnswers,
      getBackupQuestionAnswers,
      setQuestionNumber,
      setEmailAddress,
      updateSurvey,
      removeAnswers,
      setAllAnswers,
      updateActivationCode,
      resetAnswers,
      updateSessionKey,
      getAdvice,
      getThemeName,
      getLink,
      onHandleNext,
      onHandlePrevious,
      updateMetadata,
      getMetadata,
    }),
    [questionAnswers, questionNumber, question, email, survey, updateSurvey]
  );

  return <SurveyContext.Provider value={context}>{children}</SurveyContext.Provider>;
};

export default SurveyContextProvider;
